export class StaggerHelper {
  // Runs action once per item, each delayMs apart - used to avoid browsers blocking
  // several near-simultaneous file downloads triggered from a single click.
  static run<T>(items: T[], delayMs: number, action: (item: T, index: number) => void): void {
    (items ?? []).forEach((item, index) => setTimeout(() => action(item, index), index * delayMs));
  }
}
